import { DisabilityProof } from '../api/app-types/disability-proof.app';
import { mockDocument, mockDocuments } from './document-file.mock';
import { mockUser } from './user.mock';

export const mockDisabilityProofs: DisabilityProof[] = [
	{
		id: 1,
		disabilityType: 'Sehbehinderung',
		since: new Date('2020-01-15'),
		status: {
			content: 'Active status',
			limitedUntil: new Date('2024-12-31'),
			initial: 'KBS01',
		},
		remark: 'Test Bemerkung',
		advisor: mockUser,
		documents: mockDocuments,
		categoryDisabilitySeverity: {
			id: 1,
			remark: 'Schwerbehindert',
		},
		categoryDisabilityStatus: {
			id: 1,
			remark: 'Aktiv',
			initial: 'KBS01',
		},
	},
	{
		id: 2,
		disabilityType: 'Hörbehinderung',
		since: new Date('2021-03-10'),
		status: {
			content: 'Aktiv',
			initial: 'KBS01',
		},
		remark: 'Test Bemerkung 2',
		advisor: mockUser,
		documents: [mockDocument],
		categoryDisabilitySeverity: {
			id: 1,
			remark: 'Schwerbehindert',
		},
		categoryDisabilityStatus: {
			id: 1,
			remark: 'Aktiv',
			initial: 'KBS01',
		},
	},
];
